<img [src]="src || placeholderSrc"
  [srcset]="srcset"
  [sizes]="sizes"
  [attr.loading]="nativeLazy ? 'lazy' : 'eager'"
  [ngStyle]="imgStyle">